module.exports = __webpack_public_path__ + "img/element-icons-72-x-72-ic-rating-content-drug.2af18a6b.svg";